import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <p>
        Designed by Steve Anatai and Claude Sonnet, December 2025.
        <br />
        Released under <a href="https://opensource.org/licenses/MIT" target="_blank" rel="noopener noreferrer">MIT license</a>.
      </p>
    </footer>
  );
}

export default Footer;
